module.exports = __webpack_public_path__ + "img/Phone_02.435445c6.jpg";